import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { UserRole } from "../types";

// Stricter than AdminRoute: only console SUPERUSERs may pass.
// Used to gate the Keycloak management feature.
export function SuperuserRoute() {
  const { user } = useAuth();

  if (user?.role !== UserRole.SUPERUSER) {
    return <Navigate to="/services" replace />;
  }

  return <Outlet />;
}
